const AnchorLinkTag = ({
  className = '',
  children,
  hrefPath = '',
  target = '_blank',
  rel = 'noopener noreferrer',
}) => {
  return (
    <a className={`${className} underline hover:text-gray-700`} href={hrefPath} target={target} rel={rel}>
      {children}
    </a>
  );
};

export default AnchorLinkTag;
